import Reaact from 'react'
import VideoCell from './VideoCell'
import Button from 'react-bootstrap/Button'

export default class VideoCellList extends React.Component { 

	render() { 
		return <div style={{display:'flex', marginTop: 10, flexWrap: 'nowrap', overflowX: 'auto', WebkitOverflowScrolling: 'touch'}}>
				 {this.props.videos && this.props.videos.map((item, index)=> (
				 	<div>
					 	<VideoCell 
					 	key={item.id}
					 	video={item}
					 	style={{marginRight:10}}
					 	onClick={(url)=> this.props.onVideoClick(url)}/>

					 	{ this.props.edit && 
							<Button variant="outline-danger"
								style={{marginTop: 10}} 
								onClick={() => this.props.onDelete(item)}>
								Delete
							</Button>
						}
				 	</div>)
				 )
				} 	
				 </div>
	}
}